
// Do not type this object, we'll loose auto-complete of all the properties.
export const TALENT_ID = {

    MONK: {
        MW: {
            CHI_JI: "df7704d5-e271-4375-a341-8472f1951dfa",
        }
    },

    SHAMAN: {
        RESTO: {
            APT: "d3a2fafa-5822-44e4-a27b-765e185886ef",
            WRT: "c394146d-3bc1-4afa-b43c-08b2dd6a7511",
        }
    },

    PRIEST: {
        HOLY: {
            SALVATION: "1958e568-b0e7-49a4-9b16-0be843f86c0c",
        },
        DISC: {
            EVANGELISM: "93b75224-04c3-4cad-95c2-dc9066cc80ba",
            MINDBENDER: "4f8a0fb7-15cd-42ee-849e-320149468f1e",
        },
        SHADOW: {
            // Empty
        }
    },

    DRUID: {
        RESTO: {
            INNER_PEACE: "a14195ea-f9e2-4ee2-a655-a68c404191e3",
            TREE: "bfd599d2-0d21-4a53-b32b-fd5d8f33c7c3",
        },
        GUARD: {
            // Empty
        },
        FERAL: {
            // Empty
        },
    }

}
